<div class="dropdown-button" [ngClass]="{'open' : isOpen, 'sm-padding': smallPadding, 'menu-auto-width': btnImageUrl}">
    <button *ngIf="!btnImageUrl" class="btn dropdown-toggle" (click)="open()" type="button" [disabled]="disabled" [ngClass]="[large ? 'btn-lg' : small ? 'btn-sm' : '', btnClasses ]">
        <i class="m-r-xs" *ngIf="btnIconClass" [ngClass]="btnIconClass"></i>
        <span [i18n]="[{target: 'innerHTML', key: btnTextKey}]"></span> <span class="caret"></span>
    </button>
    <div *ngIf="btnImageUrl" (click)="open()">
        <img [src]="btnImageUrl">
        <span class="caret"></span>
    </div>
    <ul class="dropdown-menu dropdown-menu-right" [ngClass]="{'dropdown-menu-right': !alignLeft, 'dropdown-menu-left': alignLeft }"
        (click)="close()">
        <ng-content select="li[app-dropdown-button-item]"></ng-content>
    </ul>
</div>

<div *ngIf="isOpen" class="dropdown-mask" (click)="open()"></div>
